import React from 'react';

function StatusPill({ color = 'steel', children, title }) {
  return (
    <span className={`status-pill ${color}`} title={title}>
      <span className="status-dot" />
      {children}
    </span>
  );
}

export default StatusPill;
